export const environment = {
  production: true,
  apiUrl: 'https://apiadmin.sjcoescience.org/'
};